export class ConfigServer {
  serverPath: 'http://svnsimssql07:10604';
  boServerPath: 'http://svnsimssql07:10604';
  translationsUrl: 'http://svnsimssql07:10604/api/v1/translations/';
  toCommandsStatus: 1;
  maxFileSizeToUpload: 1000000;
}
